var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.wrapperElement,
    {
      tag: "element",
      staticClass: "checkbox-radio-switch checkbox-radio-switch-checkbox",
      class: {
        "checkbox-radio-switch--checked": _vm.isChecked,
        "checkbox-radio-switch--disabled": _vm.disabled,
        "checkbox-radio-switch--indeterminate": _vm.indeterminate,
      },
      style: _vm.cssVars,
    },
    [
      _c("input", {
        staticClass: "checkbox-radio-switch__input",
        attrs: {
          id: _vm.id,
          disabled: _vm.disabled,
          indeterminate: _vm.indeterminate,
          name: _vm.name,
          type: "checkbox",
        },
        domProps: { checked: _vm.isChecked, value: _vm.value },
        on: { change: _vm.onToggle },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "checkbox-radio-switch__label", attrs: { for: _vm.id } },
        [
          _c(_vm.checkboxRadioIconElement, {
            tag: "icon",
            staticClass: "checkbox-radio-switch__icon",
            attrs: { size: _vm.size, title: "", decorative: "" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._t("default")], 2),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }